import van from "vanjs-core"

const msg_box_id = 'rabbitloader_common_msg_modal';
const msg_box_body = 'rabbitloader_common_msg_body';
const { div } = van.tags

const modalContainer = div({
    id: `${msg_box_id}`,
    style: `position: fixed; top: 50px; left: 50%; background-color: #ffffff; border-radius: 4px; box-shadow: 0px 0px 120px #000; min-width: 400px; margin-left: -200px; text-align:center; z-index: 99999999999;`
})

const modalMsgBox = div(
    {
        id: `${msg_box_body}`,
        style: "padding: 20px;"
    }
)

const modalCloseBtn = div(
    {
        id: `rabbitloader_common_msg_footer`,
        style: "text-align: center; color: #0811fb; cursor: pointer; padding: 10px; background-color: #f4f4f4; border-radius: 4px;",
        onclick: () => { modalContainer.style.display = "none"; }
    }, 'Close'
)

function inject() {
    var dom = document.getElementById(msg_box_id);
    if (!dom) {
        const Modal = () => van.add(modalContainer,
            modalMsgBox,
            modalCloseBtn
        )
        van.add(document.body, Modal());
    } else {
        modalContainer.style.display = "block";
    }
}

function setWidth(w) {
    modalContainer.style.width = w + 'px'
    modalContainer.style.marginLeft = (-1 * w / 2) + 'px'
}

export function showCommonMessage(msg, skipPadding) {
    inject();
    let padding = skipPadding ? '0px' : '20px';
    modalMsgBox.style.padding = padding
    modalMsgBox.innerHTML = msg;
    setWidth(400)
}

export function showVideoPopup(id) {

    let msg = `<iframe src="https://www.youtube.com/embed/${id}" width="560px" height="315px" style="max-width:100%" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`

    inject();
    modalMsgBox.style.padding = '0px'
    modalMsgBox.innerHTML = msg;
    setWidth(560)
}